import {
  getCompanyChallenge,
  getUserChallenge,
  resetCompanyChallenge,
  updateCompanyChallenge,
  updateUserChallengeStep,
  updateUserTeamName,
} from '@/redux/actions/challenge';
import { ICompanyChallenge, IUserChallenge } from '@/types/challenges';
import { createSlice } from '@reduxjs/toolkit';

export interface ChallengesState {
  userChallenge: IUserChallenge | null;
  companyChallenge: ICompanyChallenge | null;
  loading: boolean;
  hasFetchedUserChallenge: boolean;
}

const initialState: ChallengesState = {
  userChallenge: null,
  companyChallenge: null,
  loading: false,
  hasFetchedUserChallenge: false,
};

export const { actions, reducer } = createSlice({
  name: 'challenges',
  initialState,
  reducers: {
    resetChallengesState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserChallenge.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserChallenge.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.hasFetchedUserChallenge = true;
        state.userChallenge = payload;
      })
      .addCase(getUserChallenge.rejected, (state) => {
        state.loading = false;
        state.hasFetchedUserChallenge = true;
      })
      .addCase(updateUserTeamName.fulfilled, (state, { payload }) => {
        if (state.userChallenge) {
          state.userChallenge = { ...state.userChallenge, ...payload };
        }
      })
      .addCase(updateUserChallengeStep.fulfilled, (state, { payload }) => {
        if (state.userChallenge) {
          state.userChallenge = { ...state.userChallenge, ...payload };
        }
      })
      .addCase(getCompanyChallenge.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanyChallenge.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.companyChallenge = payload;
      })
      .addCase(getCompanyChallenge.rejected, (state) => {
        state.loading = false;
        state.companyChallenge = null;
      })
      .addCase(updateCompanyChallenge.fulfilled, (state, { payload }) => {
        state.companyChallenge = payload;
      })
      .addCase(resetCompanyChallenge.fulfilled, (state) => {
        state.companyChallenge = null;
      });
  },
});

export const { resetChallengesState } = actions;

export default reducer;
